"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_1 = __importDefault(require("../../styled"));
var tokens_1 = require("../../tokens");
var StyledLabel = styled_1.default.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-weight: ", ";\n  word-break: break-word;\n"], ["\n  color: ", ";\n  font-weight: ", ";\n  word-break: break-word;\n"])), tokens_1.colors.text.default, tokens_1.fonts.weight.medium);
exports.default = StyledLabel;
var templateObject_1;
//# sourceMappingURL=label.js.map